import { createContext, useContext } from 'react'
import type { FinanceScope } from '../api/financeTypes'
import type { ViewMode } from '../lib/financeMode'

export interface FinanceContextValue {
  /** `null` until loaded, or when the scope call failed (then no switch). */
  scope: FinanceScope | null
  scopeLoading: boolean
  scopeError: unknown
  /** The Felhasználó | Admin switch is shown. */
  visible: boolean
  mode: ViewMode
  setMode: (mode: ViewMode) => void
  /** Selected scope option: a project id or `all` (global admin only). */
  selection: string
  setSelection: (value: string) => void
  /** `project_id` to send to the API; undefined only for "Minden projekt". */
  projectId: string | undefined
}

export const FinanceCtx = createContext<FinanceContextValue | null>(null)

export function useFinanceOptional(): FinanceContextValue | null {
  return useContext(FinanceCtx)
}

export function useFinance(): FinanceContextValue {
  const v = useContext(FinanceCtx)
  if (!v) throw new Error('useFinance() outside <FinanceProvider>')
  return v
}
